<aside class="footer-section-sponsors bg-asvz-blue">
  <div class="container">
    <h2 class="sponsor-title">ASVZ-Sponsoren</h2>
    <div class="row">
      <div class="col-xl-6 sponsor">
        <a href="https://www.craftsportswear.ch" 
           target="_blank" 
           rel="noopener noreferrer"
           aria-label="Craft Sportswear">
          <div class="sponsor-box-container">
            <div class="sponsor-box-image sponsor-box-image-craft"></div>
          </div>
        </a>
      </div>
      <div class="col-xl-6 sponsor">
        <a href="https://www.zkb.ch" 
           target="_blank" 
           rel="noopener noreferrer"
           aria-label="Zürcher Kantonalbank">
          <div class="sponsor-box-container">
            <div class="sponsor-box-image sponsor-box-image-zkb"></div>
          </div>
        </a>
      </div>
    </div>
  </div>
</aside>